import { useState } from 'react'
import { Dropdown, Key, Radio } from '@bbl-digital/snorre'
import {
  DropdownStyle,
  MultipleFiltersWrapper,
  OptionWrapper,
  Wrapper,
} from './styles'
import { css } from '@emotion/react'

type Props = {
  value: any
  values?: any[]
  advancedValues?: {
    displayText: string
    id?: string | number | null
  }[]
  defaultValue?: string | null
  className?: string
  onChange: (value?: string | number | null) => void
  id?: string
  disabled?: boolean
}

const disabledCss = css`
  pointer-events: none;
  opacity: 0.5;
`

function DropdownFilter({
  value,
  values,
  advancedValues,
  defaultValue,
  className,
  onChange,
  id,
  disabled = false,
}: Props) {
  const [triggerClose, setTriggerClose] = useState(false)

  const labelText = defaultValue
    ? defaultValue
    : advancedValues
    ? advancedValues.find((x) => x.id === value)?.displayText
    : value

  return (
    <Dropdown
      label={labelText}
      css={css(DropdownStyle, disabled && disabledCss)}
      triggerClose={triggerClose}
      onCloseTrigger={() => setTriggerClose(false)}
      className={className}
      id={id}
    >
      <Wrapper
        // close dropdown when tabbing out of it or escaping it.
        onKeyDown={(e) => {
          if (e.key === Key.escape || e.key === Key.tab) setTriggerClose(true)
        }}
      >
        {values &&
          values.map((v: string | number, index) => (
            <OptionWrapper key={index}>
              <Radio
                name="show"
                disabled={disabled}
                vertical
                checked={value === v}
                onMouseUp={() => {
                  if (!disabled) {
                    onChange(v)
                    setTriggerClose(true)
                  }
                }}
                onChange={() => {
                  if (!disabled) onChange(v)
                }}
              >
                {v}
              </Radio>
            </OptionWrapper>
          ))}
        {advancedValues &&
          advancedValues.map((v, index) => (
            <OptionWrapper key={index}>
              <Radio
                disabled={disabled}
                name="show"
                vertical
                checked={value === v.id}
                onMouseUp={() => {
                  if (!disabled) {
                    onChange(v.id)
                    setTriggerClose(true)
                  }
                }}
                onChange={() => {
                  if (!disabled) onChange(v.id)
                }}
              >
                {v.displayText}
              </Radio>
            </OptionWrapper>
          ))}
      </Wrapper>
    </Dropdown>
  )
}

DropdownFilter.Wrapper = MultipleFiltersWrapper
export default DropdownFilter
